// Filters to show in Portal panel
export const PORTAL_FILTERS_MASK = ['source', 'benchmark'] as const
// Filters to show in Filters panel
export const PANEL_FILTERS_MASK = ['trait', 'variable', 'virtual'] as const
// Filters to show in view
export const VIEW_FILTERS_MASK = ['sample'] as const

// All viewer filters
export const SHARED_FILTERS_MASK = [...PANEL_FILTERS_MASK] as const
// All viewer filters
export const VIEWER_FILTERS_MASK = [...VIEW_FILTERS_MASK, ...PANEL_FILTERS_MASK] as const
// All editor filters
export const EDITOR_FILTERS_MASK = [...VIEW_FILTERS_MASK, ...PORTAL_FILTERS_MASK, ...PANEL_FILTERS_MASK] as const

// All source filters
export const SOURCE_FILTERS_MASK = [...PORTAL_FILTERS_MASK] as const
// All model filters
export const MODEL_FILTERS_MASK = [...VIEW_FILTERS_MASK, ...PANEL_FILTERS_MASK] as const
// All filters mask
export const ALL_FILTERS_MASK = [...VIEW_FILTERS_MASK, ...PORTAL_FILTERS_MASK, ...PANEL_FILTERS_MASK] as const
